export default [
  {
    path: '/progress-reports',
    name: 'progressReports#index',
    component: () => import('@views/progressReports/index'),
    meta: {
      resourceOptional: true,
    },
  },
  {
    path: '/progress-reports/:uuid',
    name: 'progressReports#show',
    component: () => import('@views/progressReports/show'),
    meta: {
      resourceOptional: true,
    },
  },
];
